if (!customElements.get('learn-faq')) {
  class LearnFaq extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.learn-faq__item'));
      this.chips = Array.from(this.querySelectorAll('.learn-faq__chip'));
      this.select = this.querySelector('.learn-faq__select');
      this.allCount = parseInt(this.dataset.allCount, 10) || this.items.length;
      this.openFirst = this.hasAttribute('data-open-first');

      this.onClick = this.onClick.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);

      this.addEventListener('click', this.onClick);
      if (this.select) this.select.addEventListener('change', this.onChange);
      this.closest('section')?.addEventListener('shopify:block:select', this.onBlockSelect);

      if (this.dataset.initialFilter) this.filter(this.dataset.initialFilter);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      if (this.select) this.select.removeEventListener('change', this.onChange);
      this.closest('section')?.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    onClick(event) {
      const chip = event.target.closest('.learn-faq__chip');
      if (chip && this.contains(chip)) {
        this.filter(chip.dataset.filter);
        return;
      }

      const trigger = event.target.closest('.learn-faq__trigger');
      if (trigger && this.contains(trigger)) {
        this.toggle(trigger.closest('.learn-faq__item'));
      }
    }

    onChange(event) {
      this.filter(event.target.value);
    }

    onBlockSelect(event) {
      const item = event.target.closest?.('.learn-faq__item') || event.target;
      if (!(item instanceof HTMLElement) || !item.classList.contains('learn-faq__item')) return;
      if (item.hidden) this.filter(this.itemFilterFor(item));
      this.toggle(item, true);
    }

    itemFilterFor(item) {
      return item.dataset.category && item.dataset.category !== '0' ? item.dataset.category : 'all';
    }

    filter(value) {
      this.chips.forEach((chip) => {
        const active = chip.dataset.filter === value;
        chip.classList.toggle('is-active', active);
        chip.setAttribute('aria-pressed', String(active));
      });
      if (this.select && this.select.value !== value) this.select.value = value;

      this.items.forEach((item) => {
        const show =
          value === 'all'
            ? Number(item.dataset.order) <= this.allCount
            : item.dataset.category === value;
        item.hidden = !show;
      });

      this.items.forEach((item) => this.setOpen(item, false));
      if (this.openFirst) {
        const first = this.items.find((item) => !item.hidden);
        if (first) this.setOpen(first, true);
      }
    }

    toggle(item, forceOpen) {
      if (!item) return;
      const open = forceOpen === undefined ? !item.classList.contains('is-open') : forceOpen;
      this.setOpen(item, open, true);
    }

    setOpen(item, open, animate) {
      const trigger = item.querySelector('.learn-faq__trigger');
      const answer = item.querySelector('.learn-faq__answer');
      item.classList.toggle('is-open', open);
      if (trigger) trigger.setAttribute('aria-expanded', String(open));
      if (!answer) return;

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (answer.animation) answer.animation.cancel();
      if (!animate || reduce || answer.hidden === !open) {
        answer.hidden = !open;
        return;
      }

      answer.hidden = false;
      const margin = getComputedStyle(answer).marginTop;
      const height = `${answer.scrollHeight}px`;
      const closed = { height: '0px', marginTop: '0px', opacity: 0 };
      const opened = { height, marginTop: margin, opacity: 1 };
      answer.style.overflow = 'hidden';
      answer.animation = answer.animate(open ? [closed, opened] : [opened, closed], {
        duration: 320,
        easing: 'cubic-bezier(0.25, 0.8, 0.25, 1)',
      });
      answer.animation.onfinish = () => {
        answer.style.overflow = '';
        answer.animation = null;
        if (!open) answer.hidden = true;
      };
    }
  }

  customElements.define('learn-faq', LearnFaq);
}
